import aeroplaneIcon from '@/assets/homepage-bme/aeroplane.png'
import BeMyEyesLogo from '@/assets/homepage-bme/beMyEyes.svg?react'
import bmeLogo from '@/assets/homepage-bme/bmePartnership.png'
import CrossLogo from '@/assets/homepage-bme/crossPartnership.svg'
import emoji from '@/assets/homepage-bme/emoji.png'
import gridIcon1 from '@/assets/homepage-bme/gridIcon1.png'
import gridIcon2 from '@/assets/homepage-bme/gridIcon2.svg'
import GridIcon2Component from '@/assets/homepage-bme/gridIcon2.svg?react'
import gridIcon3 from '@/assets/homepage-bme/gridIcon3.png'
import GridIcon4Component from '@/assets/homepage-bme/gridIcon4.svg?react'
import innosearchLogoDark from '@/assets/homepage-bme/innosearchLogoPartnershipDark.png'
import innosearchLogoLight from '@/assets/homepage-bme/innosearchLogoPartnershipLight.png'
import iPhoneImage from '@/assets/homepage-bme/iPhoneImage.png?minW=184&picture-image-tools'
import pizzaIcon from '@/assets/homepage-bme/pizza.png'
import playIcon from '@/assets/homepage-bme/play.png'
import rightArrowIcon from '@/assets/homepage-bme/rightArrow.png'
import shopIcon from '@/assets/homepage-bme/shop.png'
import teamedUpImage from '@/assets/homepage-bme/teamedup.png?minW=681&picture-image-tools'
import CashbackVector from '@/assets/homepage-bme/vectorCashback.svg?react'
import video1 from '@/assets/homepage-bme/video1.png?minW=350&picture-image-tools'
import video2 from '@/assets/homepage-bme/video2.png?minW=350&picture-image-tools'
import video3 from '@/assets/homepage-bme/video3.png'
import acbImg from '@/assets/images/media-mentions/acb.png'
import acbDarkImg from '@/assets/images/media-mentions/acb-dark.png'
import afbImg from '@/assets/images/media-mentions/afb.png'
import afbDarkImg from '@/assets/images/media-mentions/afb-dark.png'
import blindlifeImg from '@/assets/images/media-mentions/blindlife.png'
import blindlifeDarkImg from '@/assets/images/media-mentions/blindlife-dark.png'
import nfbImg from '@/assets/images/media-mentions/nfb.png'
import nfbDarkImg from '@/assets/images/media-mentions/nfb-dark.png'
import Picture from '@/components/Picture'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import {Theme} from '@/lib/theme/theme'
import {useCurrentTheme} from '@/lib/theme/useCurrentTheme'

import style from './BeMyEyesSection.module.scss'

const whyWeTeamedUpFactors = [
  {
    title: 'Mission Alignment',
    subtitle: 'Accessibility, inclusion, and user empowerment',
  },
  {
    title: 'Faster Together',
    subtitle: 'Speed-to-impact is better through partnership',
  },
  {
    title: 'Community-Driven',
    subtitle: 'Early users love the InnoSearch experience',
  },
  {
    title: 'Vision-Aligned',
    subtitle: 'A step toward "The Everything App" for independence',
  },
]

const offerings = [
  {
    icon: shopIcon,
    alt: '',
    iconContainerClass: style.OfferingCardIconShop,
    iconClass: style.OfferingCardIconShopImage,
    title: 'Shop 500,000+ Retailers',
    subtitle: 'Billions of products, easily searchable by voice or keyboard',
  },
  {
    icon: pizzaIcon,
    alt: '',
    iconContainerClass: style.OfferingCardIconPizza,
    iconClass: style.OfferingCardIconPizzaImage,
    title: 'Food & Grocery Delivery',
    subtitle: 'Fully accessible, with one-hour delivery in select markets',
  },
  {
    icon: aeroplaneIcon,
    alt: '',
    iconContainerClass: style.OfferingCardIconAeroplane,
    iconClass: style.OfferingCardIconAeroplaneImage,
    title: 'Accessible Flight Booking',
    subtitle: 'Plan, compare, and book — all in a screen reader–friendly flow',
  },
]

const whyDifferentItems = [
  {
    icon: gridIcon1,
    alt: '',
    text: 'Clean, simplified, all-in-one layout — no ads, no clutter, no pop-ups',
  },
  {
    icon: gridIcon2,
    alt: '',
    text: 'Friendly, 24/7 support — trained to assist blind and low vision users',
  },
  {
    icon: gridIcon3,
    alt: '',
    text: 'AI-powered chatbot — helps users find products, understand details, and even "chat" with images',
  },
  {
    icon: 'gridIcon4',
    alt: '',
    text: 'Full voice and keyboard navigation — no advanced screen reader skills needed',
  },
]

const impacts = [
  {
    highlightedStat: '4,000+',
    remainingText: 'Users Served',
    subtitle: 'Across the U.S., U.K., Australia, and Canada',
  },
  {
    highlightedStat: '1–2 Hours',
    remainingText: 'Saved per Shopping Trip',
    subtitle: 'Thanks to simplified, accessible navigation',
  },
  {
    highlightedStat: '80%',
    remainingText: 'Report Increased Independence',
    subtitle: 'With better search, alt text, and support',
  },
]

const impactLogos = [
  [
    {
      component: BeMyEyesLogo,
      alt: 'Be My Eyes logo',
      containerClass: style.ImpactLogo1Container,
      className: style.ImpactLogo1,
    },
    {
      image: {
        light: blindlifeImg,
        dark: blindlifeDarkImg,
      },
      alt: 'The Blind Life logo',
      containerClass: style.ImpactLogo2Container,
      className: style.ImpactLogo2,
    },
  ],
  [
    {
      image: {
        light: nfbImg,
        dark: nfbDarkImg,
      },
      alt: 'National Federation of the Blind logo',
      containerClass: style.ImpactLogo3Container,
      className: style.ImpactLogo3,
    },
    {
      image: {
        light: afbImg,
        dark: afbDarkImg,
      },
      alt: 'American Foundation for the Blind logo',
      containerClass: style.ImpactLogo4Container,
      className: style.ImpactLogo4,
    },
    {
      image: {
        light: acbImg,
        dark: acbDarkImg,
      },
      alt: 'American Council of the Blind',
      containerClass: style.ImpactLogo5Container,
      className: style.ImpactLogo5,
    },
  ],
]

const videos = [
  {
    title: 'The Blind Life Interview',
    thumbnail: video1,
    alt: 'Watch the Blind Life Interview with Mike Buckley from Be My Eyes and Patrick Long from InnoSearch',
    videoClass: style.Video1,
    url: 'https://www.youtube.com/watch?v=Xs0WSsn_AIg&ab_channel=TheBlindLife',
    description: 'Mike Buckley (BME) & Patrick Long (InnoSearch) with Sam Seavey',
    buttonText: 'Watch on YouTube',
  },
  {
    title: 'Double Tap Interview',
    thumbnail: video2,
    alt: 'Watch the Double Tap Interview with Patrick Long from InnoSearch, talking about accessibility and why this matters',
    videoClass: style.Video2,
    url: 'https://www.youtube.com/watch?v=80SQDfQi5s4&ab_channel=DoubleTap-Whereblindpeopletalktech',
    description: 'Talking Tech, Accessibility & Why This Matters',
    buttonText: 'Watch on YouTube',
  },
  {
    title: 'Official Press Release',
    thumbnail: video3,
    alt: 'Link to the official press release from Be My Eyes and InnoSearch',
    videoClass: style.Video3,
    url: 'https://www.bemyeyes.com/news/be-my-eyes-to-provide-in-app-accessible-shopping/',
    description: 'In-App Accessible Shopping for the Blind, powered by InnoSearch',
    buttonText: 'Read on Be My Eyes News',
  },
]

export default function BeMyEyesSection() {
  const [currentTheme] = useCurrentTheme()

  const scrollToSearchInput = () => {
    const searchContainer = document.querySelector(
      '[role="search"][aria-label="Search for products"]',
    )

    if (searchContainer) {
      searchContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })

      setTimeout(() => {
        const searchInput = searchContainer.querySelector('input')
        searchInput?.focus()
      }, 600)
    }
  }

  const renderIcon = (item: (typeof whyDifferentItems)[0], index: number) => {
    const iconComponents: Record<number, React.ReactNode> = {
      1: <GridIcon2Component className={style.Icon} aria-hidden='true' />,
      3: <GridIcon4Component className={style.Icon} aria-hidden='true' />,
    }

    const specialComponent = iconComponents[index]
    if (specialComponent) {
      return specialComponent
    }

    return <img src={item.icon} alt={item.alt} className={style.Icon} />
  }

  return (
    <section className={style.Container}>
      <div className={style.PartnershipSection}>
        <div className={style.LeftSection}>
          <div className={style.TextSection}>
            <h2 className={style.PartnershipTitle}>
              Be My Eyes and InnoSearch Join Forces to Make Online Shopping Easier
            </h2>
            <p className={style.PartnershipSubtitle}>
              A partnership built on accessibility, independence, and innovation – with 2% cashback
              for all Be My Eyes users who shop through InnoSearch.
            </p>
          </div>
          <PrimaryButton size='lg' onPress={scrollToSearchInput}>
            Shop Now with 2% Cashback
          </PrimaryButton>
        </div>
        <div className={style.RightSection}>
          <div className={style.PinkEllipse} />
          <div className={style.BlueEllipse} />
          <img
            src={currentTheme === Theme.Dark ? innosearchLogoDark : innosearchLogoLight}
            alt='InnoSearch.ai'
            className={style.InnosearchLogo}
          />
          <img src={bmeLogo} alt='Be My Eyes' className={style.BmeLogo} />
          <img src={CrossLogo} alt='' className={style.CrossLogo} />
        </div>
      </div>

      <div className={style.WhyWeTeamedUpSection}>
        <div className={style.TopSection}>
          <h2 className={style.WhyTitle}>WHY WE TEAMED UP</h2>
          <h3
            className={style.WhySubtitle}
            aria-label="We've Heard You Now We're Building With You"
          >
            <span aria-hidden='true'>
              We've Heard You <br />
              Now We're Building With You
            </span>
          </h3>
          <div className={style.Body}>
            Be My Eyes is the world's most popular accessibility platform for people who are blind
            or have low vision, but when it comes to shopping, InnoSearch AI are the specialists.
            That's why Be My Eyes and InnoSearch AI have worked together to bring a seamless,
            accessible online shopping experience directly to the largest community of blind and low
            vision people
          </div>
        </div>
        <div className={style.BottomSection}>
          <Picture
            src={{pic: teamedUpImage}}
            alt='Be My Eyes and InnoSearch teaming up'
            loading='lazy'
            sizes='(max-width: 767px) 100vw, (max-width: 1023px) 560px, 681px'
            className={style.Image}
          />
          <div className={style.FactorsSection}>
            {whyWeTeamedUpFactors.map(({title, subtitle}, index) => (
              <div key={title} className={style.NumberBulletContainer}>
                <div className={style.NumberBullet} aria-hidden='true'>
                  {index + 1}
                </div>
                <div className={style.FactorContentContainer}>
                  <h4 className={style.FactorTitle}>{title}</h4>
                  <p className={style.FactorSubtitle}>{subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={style.InaccessibleStatsSection}>
        <div className={style.OuterTextContainer}>
          <div className={style.InnerTextContainer}>
            <div className={style.LeftTextSection}>
              <h2 className={style.LeftTextTitle}>
                98% of Websites Are Inaccessible <img src={emoji} alt='' />
              </h2>
              <div className={style.LeftTextSubtitle}>- American Foundation for the Blind</div>
            </div>

            <div className={style.RightTextSection}>
              Most online stores are built for people who can easily see images, close pop-ups, and
              navigate complex layouts. InnoSearch is different. We built it for those who can’t.
            </div>
          </div>
        </div>
      </div>

      <div className={style.OfferingsSection}>
        <h2 className={style.OfferingsTitle}>What InnoSearch Offers</h2>
        <div className={style.OfferingsContainer}>
          {offerings.map(({icon, alt, iconContainerClass, iconClass, title, subtitle}) => (
            <div key={title} className={style.OuterOfferingCardsContainer}>
              <div className={style.InnerOfferingCardContainer}>
                <div className={iconContainerClass}>
                  <img src={icon} alt={alt} className={iconClass} />
                </div>
                <h3 className={style.OfferingCardTitle}>{title}</h3>
                <div className={style.OfferingCardSubtitle}>{subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={style.WhyDifferentSection}>
        <div className={style.WhyDifferentLeftSection}>
          <h2 className={style.WhyDifferentTitle}>Why InnoSearch is Different?</h2>
        </div>
        <div className={style.WhyDifferentRightSection}>
          <div className={style.GridContainer}>
            {whyDifferentItems.map((item, index) => (
              <div key={item.text} className={style.GridItemContainer}>
                <div className={style.IconContainer}>{renderIcon(item, index)}</div>
                <div className={style.GridItemText}>{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={style.ImpactSection}>
        <div className={style.ImpactLeftSection}>
          <Picture
            src={{pic: iPhoneImage}}
            alt=''
            className={style.IPhoneImage}
            loading='lazy'
            sizes='(max-width: 767px) 184px, (max-width: 1023px) 192px, 184px'
          />
        </div>
        <div className={style.ImpactRightSection}>
          <h2 className={style.ImpactTitle}>Our Impact So Far</h2>
          <div className={style.ImpactsSection}>
            {impacts.map(({highlightedStat, remainingText, subtitle}) => (
              <div key={highlightedStat} className={style.IndividualImpactContainer}>
                <div className={style.ImpactStats}>
                  <span>{highlightedStat}</span> {remainingText}
                </div>
                <div className={style.ImpactSubtitle}>{subtitle}</div>
              </div>
            ))}
          </div>
          <div className={style.ImpactLogosSection}>
            {impactLogos.map((row, rowIndex) => (
              <div key={`logo-row-${rowIndex}`} className={style.LogoRow}>
                {row.map(item => {
                  let image
                  if (item.image) {
                    image = currentTheme === Theme.Dark ? item.image.dark : item.image.light
                  }

                  return (
                    <div key={item.alt} className={item.containerClass}>
                      {item.component ? (
                        <item.component
                          className={item.className}
                          role='img'
                          aria-label={item.alt}
                        />
                      ) : (
                        <img src={image} alt={item.alt} className={item.className} />
                      )}
                    </div>
                  )
                })}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={style.WatchSection}>
        <h2 className={style.WatchTitle}>HEAR THE STORY - WATCH & LISTEN</h2>
        <h3 className={style.WatchSubtitle}>
          Hear Directly from the Leaders Behind This Partnership
        </h3>
      </div>

      <div className={style.VideosSection}>
        {videos.map(({title, thumbnail, alt, videoClass, url, description, buttonText}) => (
          <a
            key={title}
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            className={style.VideoContainer}
            aria-label={`${title}: ${description} - ${buttonText}`}
          >
            <h4 className={style.VideoTitle}>{title}</h4>
            <div className={style.VideoClipContainer}>
              {videoClass === style.Video3 ? (
                <img src={thumbnail as string} alt={alt} className={videoClass} />
              ) : (
                <Picture
                  src={{pic: thumbnail as Exclude<typeof thumbnail, string>}}
                  alt={alt}
                  className={videoClass}
                  loading='lazy'
                  sizes='(max-width: 767px) 100vw, (max-width: 1023px) 400px, 350px'
                />
              )}
              <img src={playIcon} alt='Play' className={style.PlayIcon} aria-hidden='true' />
            </div>
            <div className={style.VideoDescription}>{description}</div>
            <div className={style.VideoButtonContainer}>
              <div className={style.VideoButtonText}>{buttonText}</div>
              <img src={rightArrowIcon} alt='' className={style.RightArrowIcon} />
            </div>
          </a>
        ))}
      </div>

      <div className={style.CashbackSection}>
        <CashbackVector className={style.Vector} aria-hidden='true' />
        <div className={style.CashbackInnerSection}>
          <div className={style.CashbackLeft}>
            <img src={bmeLogo} alt='Be My Eyes logo' className={style.BmeLogoCashback} />
            <h2
              className={style.CashbackTitle}
              aria-label='Get 2% Cashback on Every Order — Just for Being a Be My Eyes User'
            >
              Get <span aria-hidden='true'>2% Cashback</span> on Every Order — Just for Being a Be
              My Eyes User
            </h2>
          </div>
          <div className={style.CashbackRight}>
            <div className={style.CashbackThankYou}>
              As a thank-you to the community, every Be My Eyes referral gets 2% cashback on
              purchases made through InnoSearch. No codes. No forms. Just start shopping.
            </div>
            <PrimaryButton size='lg' onPress={scrollToSearchInput}>
              Shop Now with 2% Cashback
            </PrimaryButton>
          </div>
        </div>
      </div>
    </section>
  )
}
